import { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { handleAddEquipment, handleEditEquipmentData } from '../ApiHandler/equipmentFunctions';
import ViewEquipments from './ViewEquipments';

const AddEquipment = ({ role, editFormData, handleClose }) => {
    const isEditing = !!editFormData;
    const [equipmentData, setEquipmentData] = useState({
        equipmentName: editFormData ? editFormData.equipment_name || editFormData.name || "" : "",
        equipmentDescription: editFormData ? editFormData.equipment_description || editFormData.description || "" : "",
        warrantyStatus: editFormData ? editFormData.warranty_status || "" : "",
        equipmentQuantity: editFormData ? editFormData.quantity || editFormData.equipment_quantity || "" : "",
        serialNumber: editFormData ? editFormData.serial_number || "" : "",
        expiryDate: editFormData ? (editFormData.expiry_date ? editFormData.expiry_date.split('T')[0] : editFormData.warranty_expiry_date ? editFormData.warranty_expiry_date.split('T')[0] : "") : ""
    });

    
    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (isEditing) {
            const mappedData = {
                equipmentName: equipmentData.equipmentName,
                equipmentDescription: equipmentData.equipmentDescription,
                warrantyStatus: equipmentData.warrantyStatus,
                serialNumber: equipmentData.serialNumber,
                expiryDate: equipmentData.expiryDate,
                equipmentQuantity: equipmentData.equipmentQuantity
            };
            await handleEditEquipmentData(e, editFormData.id, mappedData);
            if (handleClose) handleClose();
        } else {
            handleAddEquipment(e, equipmentData, setEquipmentData);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEquipmentData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    return (
        <div className="upload-document-container">
            <ToastContainer />
            <header className="upload-document-header">
                <h1>{isEditing ? 'Edit Equipment Data' : 'Add Equipment'}</h1>
            </header>
            <form className="upload-document-form" onSubmit={handleFormSubmit}>
                <div className="form-group">
                    <label>Equipment Name <m style={{ color: 'red' }}>*</m></label>
                    <input
                        type="text"
                        name="equipmentName"
                        value={equipmentData.equipmentName}
                        onChange={handleChange}
                        maxLength={100}
                        placeholder="Enter Equipment Name"
                        autoComplete='off'
                        required
                    />
                    <label style={{ color: 'red', fontWeight: '350', fontSize: '12px' }}>Maximum Characters: 100</label>
                </div>
                <div className="form-group">
                    <label>Equipment Description <m style={{ color: 'red' }}>*</m></label>
                    <textarea
                        type="text"
                        name="equipmentDescription"
                        value={equipmentData.equipmentDescription}
                        onChange={handleChange}
                        maxLength={250}
                        placeholder="Enter Equipment Description"
                        autoComplete='off'
                        required
                    />
                    <label style={{ color: 'red', fontWeight: '350', fontSize: '12px' }}>Maximum Characters: 250</label>
                </div>
                <div className='in-row-input'>
                    <div className="form-group">
                        <label>Warranty Status <m style={{ color: 'red' }}>*</m></label>
                        <select name="warrantyStatus" value={equipmentData.warrantyStatus} onChange={handleChange} required>
                            <option value="">Select</option>
                            <option value="Active">In Warranty (Active)</option>
                            <option value="Expired">Out of Warranty (Expired)</option>
                            <option value="Unknown">Unknown</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label>Quantity <m style={{ color: 'red' }}>*</m></label>
                        <input
                            type="number"
                            name="equipmentQuantity"
                            value={equipmentData.equipmentQuantity}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value) && value <= 9999) {
                                    handleChange(e);
                                }
                            }}
                            placeholder="Enter Quantity of Equipment"
                            autoComplete="off"
                            required
                        />
                    </div>
                </div>
                <div className='in-row-input'>
                    <div className="form-group">
                        <label>Date of Expiry<m style={{ color: 'red' }}>*</m></label>
                        <input
                            type="date"
                            name="expiryDate"
                            value={equipmentData.expiryDate}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Serial Number</label>
                        <input
                            type="text"
                            name="serialNumber"
                            value={equipmentData.serialNumber}
                            onChange={handleChange}
                            maxLength={50}
                            placeholder="Enter Serial Number"
                            autoComplete='off'
                        />
                    </div>
                </div>
                <div className="form-group">
                    <button type="submit">{isEditing ? 'Update' : 'Submit'}</button>
                    {isEditing && <button type="button" onClick={handleClose} style={{marginLeft: '10px', backgroundColor: '#6c757d'}}>Cancel</button>}
                </div>
            </form>

            {!isEditing && (
                <div style={{ marginTop: '40px' }}>
                    <ViewEquipments role={role} showAllEntities={false} />
                </div>
            )}
        </div>
    );
};

export default AddEquipment;